import React from 'react';

export function Footer() {
  return (
    <footer className="footer">
      <div className="footer-links">
        <a 
          href="https://x.com/chenieder80/status/1871547805803987035" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          X.com
        </a>
        <span>•</span>
        <a 
          href="https://t.me/eBTConPulsechain" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Telegram
        </a>
        <span>•</span>
        <a 
          href="https://snowscan.xyz/token/0x6359f700cb7a00a91b21c528757683958adf96ee" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          Contract
        </a>
        <span>•</span>
        <a 
          href="https://github.com/TreeCityWes/bitmemecoin" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          GitHub
        </a>
      </div>
    </footer>
  );
} 
